import template from './fileAddPartiesModal.html';
import controller from './fileAddPartiesModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    opportunityId: '<',
    adviserId: '<',
  },
};
